import React from "react";
import PropTypes from "prop-types";
import { Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";
import Pane from "lib/common/twopanemultiselect/Pane";
import Button from "lib/common/descriptorcontrols/BaseControls/Button";
class TwoPaneMultiSelect extends React.Component {

    constructor(...args) {
        super(...args);
        this.scrollSubject = new Subject();
        this.onScroll = this.onScroll.bind(this);
    }

    componentDidMount() {
        this.scrollSubscription = this.scrollSubject
            .pipe(
                debounceTime(100),
            )
            .subscribe(state => this.props.onHandleScroll(state));
    }

    componentWillUnmount() {
        this.scrollSubscription.unsubscribe();
    }

    onScroll(event, source) {
        this.scrollSubject.next({
            top: event.currentTarget.scrollTop,
            source,
        });
    }

    handleToggleAll(groups) {
        const { onToggleItem } = this.props;
        groups.forEach(group => {
            const { key: groupKey, items } = group;
            items.forEach(({ key: itemKey }) => {
                onToggleItem(groupKey, itemKey);
            });
        });
    }

    render() {
        const {
            onToggleItem,
            onUpdatePositions,
            scrollState,
            unselectedTree,
            selectedTree,
            contentBlocks,
        } = this.props;
        const {
            header: headerContent,
            unselectedPane = "Unselected",
            selectIcon = "Select",
            selectedPane = "Selected",
            unselectIcon = "Unselect",
            footer: footerContent,
        } = contentBlocks || {};

        const flexContainerStyles = {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingRight: "5px"
        };

        return (
            <div id="two-pane-multi-select">
                {headerContent}
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-6">
                            <div style={flexContainerStyles}>
                                <h2>{unselectedPane}</h2>
                                <Button label="Select All" onClick={() => this.handleToggleAll(unselectedTree)} className="btn btn-xs btn-default" enabled style={{ height: "40px" }}/>
                            </div>
                            <div id="unselected-list">
                                <Pane
                                    type="unselected"
                                    iconTitle={selectIcon}
                                    groups={unselectedTree}
                                    scrollState={scrollState.unselected}
                                    toggleItem={onToggleItem}
                                    updatePositions={onUpdatePositions}
                                    handleScroll={e => this.onScroll(e, "unselected")}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div style={flexContainerStyles}>
                                <h2>{selectedPane}</h2>
                                <Button label="Clear All" onClick={() => this.handleToggleAll(selectedTree)} className="btn btn-xs btn-default" enabled style={{ height: "40px" }}/>
                            </div>
                            <div id="selected-list">
                                <Pane
                                    type="selected"
                                    iconTitle={unselectIcon}
                                    groups={selectedTree}
                                    scrollState={scrollState.selected}
                                    toggleItem={onToggleItem}
                                    updatePositions={onUpdatePositions}
                                    handleScroll={e => this.onScroll(e, "selected")}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {footerContent && <div style={{margin: "0.5em"}}>{footerContent}</div>}
                <div className="modal-footer">
                    <a href="#" className="btn btn-save save"
                       onClick={event => {
                           event.preventDefault();
                           this.props.triggerSave();
                           this.props.triggerClose();
                       }}>Save</a>
                </div>
            </div>
        );
    }
}

const groupsPropType = PropTypes.arrayOf(
    PropTypes.shape({
        items: PropTypes.arrayOf(PropTypes.shape({
            key: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
        })),
        key: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
    }),
);

export const contentBlocksType = PropTypes.shape({
    header: PropTypes.string,
    unselectedPane: PropTypes.string,
    selectIcon: PropTypes.string,
    selectedPane: PropTypes.string,
    unselectIcon: PropTypes.string,
    footer: PropTypes.string,
});

TwoPaneMultiSelect.propTypes = {
    unselectedTree: groupsPropType.isRequired,
    selectedTree: groupsPropType.isRequired,
    scrollState: PropTypes.object.isRequired,
    onToggleItem: PropTypes.func.isRequired,
    onHandleScroll: PropTypes.func.isRequired,
    onUpdatePositions: PropTypes.func.isRequired,
    triggerSave: PropTypes.func,
    triggerClose: PropTypes.func,
    contentBlocks: contentBlocksType,
};

export default TwoPaneMultiSelect;



// WEBPACK FOOTER //
// ./app/lib/common/twopanemultiselect/TwoPaneMultiSelect.js